import React from "react";
import { useNavigate } from "react-router-dom";
import { IoBedOutline } from "react-icons/io5";
import { PiBathtub } from "react-icons/pi";
import { MdSquareFoot } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";
import MeetingRoomTwoToneIcon from "@mui/icons-material/MeetingRoomTwoTone";
import "./PropertyCard.css"; // Assuming you have a CSS file for styling

const PropertyCard = ({ property }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/properties/${property.title}/${property.propertyId}`);
  };

  const renderIcons = () => {
    switch (property.propertyType.toLowerCase()) {
      case "house":
        return (
          <>
            <div className="icon-detail">
              <i className="icon-beds">
                <IoBedOutline />
              </i>
              <p>Dhomat</p>
              <span>{property.bedrooms}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-baths">
                <PiBathtub />
              </i>
              <p>Banjo</p>
              <span>{property.bathrooms}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-levels">
                <SiLevelsdotfyi />
              </i>
              <p>Katet</p>
              <span>{property.floorLevel}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-sqft">
                <MdSquareFoot />
              </i>
              <p>Sipërfaqja</p>
              <span>{property.squareFeet}m²</span>
            </div>
          </>
        );
      case "apartment":
        return (
          <>
            <div className="icon-detail">
              <i className="icon-beds">
                <IoBedOutline />
              </i>
              <p>Dhomat</p>
              <span>{property.bedrooms}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-baths">
                <PiBathtub />
              </i>
              <p>Banjo</p>
              <span>{property.bathrooms}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-levels">
                <SiLevelsdotfyi />
              </i>
              <p>Kati</p>
              <span>{property.floorLevel}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-sqft">
                <MdSquareFoot />
              </i>
              <p>Sipërfaqja</p>
              <span>{property.squareFeet}m²</span>
            </div>
          </>
        );

      case "office":
      case "store":
        return (
          <>
            <div className="icon-detail">
              <i className="icon-spaces">
                <MeetingRoomTwoToneIcon />
              </i>
              <p>Hapësirat</p>
              <span>{property.spaces}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-toilets">
                <PiBathtub />
              </i>
              <p>Banjo</p>
              <span>{property.bathrooms}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-levels">
                <SiLevelsdotfyi />
              </i>
              <p>Kati</p>
              <span>{property.floorLevel}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-sqft">
                <MdSquareFoot />
              </i>
              <p>Sipërfaqja</p>
              <span>{property.squareFeet}m²</span>
            </div>
          </>
        );

      case "land":
        return (
          <div className="icon-detail" style={{ justifyContent: "center" }}>
            <i className="icon-sqft">
              <MdSquareFoot />
            </i>
            <p>Sipërfaqja</p>
            <span>{property.squareFeet}m²</span>
          </div>
        );

      case "building":
        return (
          <>
            <div className="icon-detail">
              <i className="icon-spaces">
                <MeetingRoomTwoToneIcon />
              </i>
              <p>Hapësirat</p>
              <span>{property.spaces}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-levels">
                <SiLevelsdotfyi />
              </i>
              <p>Kati</p>
              <span>{property.floorLevel}</span>
            </div>
            <div className="icon-detail">
              <i className="icon-sqft">
                <MdSquareFoot />
              </i>
              <p>Sipërfaqja</p>
              <span>{property.squareFeet}m²</span>
            </div>
          </>
        );

      default:
        return null;
    }
  };
  const getPropertyTypeName = (propertyType) => {
    const typeMapping = {
      house: "Shtëpi",
      apartment: "Banesa",
      office: "Zyrë",
      store: "Lokal",
      land: "Toka",
      building: "Objekte",
    };

    // Return the mapped name or the original type if not found
    return typeMapping[propertyType.toLowerCase()] || propertyType;
  };

  return (
    <div className="property-card" onClick={handleCardClick}>
      <span className="property-preview-tag">
        {property.isForSale ? "SHITJE" : "QERA"}
      </span>
      <span className="property-preview-tag-type">
        {getPropertyTypeName(property.propertyType)}
      </span>

      <div className="property-image-container">
        <img
          src={property.images?.[0]?.imageUrl}
          alt={property.title}
          className="property-image"
        />
      </div>
      <div className="property-details">
        <h3 className="property-title">{property.title}</h3>
        <p className="property-location">{property.city}</p>
        <p className="property-price">€{property.price.toLocaleString()}</p>
        <hr />
        <div className="property-icons">{renderIcons()}</div>
      </div>
    </div>
  );
};

export default PropertyCard;
